import { render, staticRenderFns } from "./NotificationPermission.vue?vue&type=template&id=0018f1e4&scoped=true"
import script from "./NotificationPermission.vue?vue&type=script&lang=js"
export * from "./NotificationPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018f1e4",
  null
  
)

export default component.exports